export default "__VITE_ASSET__Bw2hnweW__"